import { SxProps, Theme } from '@mui/material';
import { atlasSemantic } from 'src/theme/atlas/tokens';
import { typographySemantic } from 'src/theme/atlas/typography';

const FIELD_MIN_WIDTH = 180;

export const field: SxProps<Theme> = {
  minWidth: FIELD_MIN_WIDTH,
};

export const placeholderText: SxProps<Theme> = {
  color: atlasSemantic.color.type.disabled,
  fontSize: typographySemantic.body.fontSize,
  lineHeight: 'inherit',
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
